import BaseApi from '@/api/base-api'

class MerchantDcsApi extends BaseApi {
  fetchDcs = () => {
    return this.request({
      method: 'GET',
      path: `/merchants/cases?status[]=open&status[]=reopened`,
    })
  }

  fetchCaseDetails = (caseId) => {
    return this.request({
      method: 'GET',
      path: `/merchants/cases/${caseId}`,
    })
  }
}

export default new MerchantDcsApi()
